import { gql } from '@apollo/client';
export const GET_WEB_API_CLIENTS = gql `
  query getWebApiClients {
    webApiClients {
      id
      clientId
      clientSecret
      name
      description
      createdBy
      createdByCompanyUser {
        user {
          name
        }
      }
    }
  }
`;
